module.exports = __webpack_public_path__ + "img/image3.c60f6829.png";